import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Pill } from '@99designs/common/components/Pill';
import { DesignerLevel } from 'apps/find-designers/propTypes';
import { LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP } from 'apps/find-designers/consts';

function levelName(level) {
    switch (level) {
        case LEVEL_ENTRY:
            return <FormattedMessage id="designer_level_entry" />;
        case LEVEL_MID:
            return <FormattedMessage id="designer_level_mid" />;
        case LEVEL_TOP:
            return <FormattedMessage id="designer_level_top" />;
        default:
            return null;
    }
}

export default function LevelPill({ level }) {
    return <Pill variations={[`${level}-level`]}>{levelName(level)}</Pill>;
}

LevelPill.propTypes = {
    level: DesignerLevel.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/Designers/LevelPill.jsx